import React from 'react';
import { ModalContentItemData } from '../../types';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface ModalContentItemProps extends ModalContentItemData {
  showSelection: boolean;
  showDivider: boolean;
  showArrow: boolean;
  endIcon?: JSX.Element;
}

export const ModalContentItem: React.FC<ModalContentItemProps> = ({
  icon: startIcon,
  description,
  onPress,
  showDivider,
  showSelection,
  showArrow,
  title,
  isSelected,
  endIcon,
}) => {
  return (
    <div className="modal-contents-list-item" onClick={onPress}>
      <div className="item-contents">
        {startIcon}
        <div
          className={`item-contents-info ${showDivider ? 'item-divider' : ''}`}
        >
          <div className="item-contents-info-title">{title}</div>
          {description && (
            <div className="item-contents-info-description">{description}</div>
          )}
        </div>
      </div>
      {endIcon}
      {showSelection &&
        (isSelected ? (
          <RadioButtonCheckedIcon />
        ) : (
          <RadioButtonUncheckedIcon />
        ))}
      {showArrow && <ArrowForwardIosIcon sx={{ color: '#262626' }} />}
    </div>
  );
};
